import { OemSatellite } from '@app/app/objects/oem-satellite';
import { PluginRegistry } from '@app/engine/core/plugin-registry';
import { ServiceLocator } from '@app/engine/core/service-locator';
import { SelectSatManager } from '@app/plugins/select-sat-manager/select-sat-manager';
import { DetailedSatellite, eci2rae } from '@ootk/src/main';
import { Line, LineColors } from './line';
export class SensorToSatLine extends Line {
    sat;
    sensor;
    isDrawFovOnly_ = false;
    isDrawSelectedOnly_ = false;
    constructor(sensor, sat, color) {
        super();
        this.sat = sat;
        this.sensor = sensor;
        this.color_ = color || LineColors.GREEN;
    }
    setDrawFovOnly(drawFovOnly) {
        this.isDrawFovOnly_ = drawFovOnly;
    }
    setDrawSelectedOnly(drawSelectedOnly) {
        this.isDrawSelectedOnly_ = drawSelectedOnly;
    }
    update() {
        const posData = ServiceLocator.getDotsManager().positionData;
        const id = this.sat.id;
        const eciArr = [posData[id * 3], posData[id * 3 + 1], posData[id * 3 + 2]];
        const sensorEci = this.sensor.eci(ServiceLocator.getTimeManager().simulationTimeObj);
        const sensorEciArr = [sensorEci.x, sensorEci.y, sensorEci.z];
        this.isDraw_ = true;
        if (this.isDrawFovOnly_) {
            let isInFov = false;
            if (this.sat instanceof OemSatellite) {
                const rae = eci2rae(ServiceLocator.getTimeManager().simulationTimeObj, this.sat.position, this.sensor);
                isInFov = this.sensor.isRaeInFov(rae);
            }
            else if (this.sat instanceof DetailedSatellite) {
                isInFov = this.sensor.isSatInFov(this.sat, ServiceLocator.getTimeManager().simulationTimeObj);
            }
            if (!isInFov) {
                this.isDraw_ = false;
                this.isGarbage = true;
            }
        }
        if (this.isDrawSelectedOnly_) {
            if (this.sat.id !== PluginRegistry.getPlugin(SelectSatManager).selectedSat) {
                this.isDraw_ = false;
                this.isGarbage = true;
            }
        }
        this.updateVertBuf([eciArr, sensorEciArr]);
    }
}
